import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';

// Doküman başlığını fizyoterapistler için güncelle
document.title = 'FTR Hasta Takip | Fizyoterapistler İçin Hasta Takip Sistemi';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);